import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMapPin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "inherit",
		d: "M7.03 6.03a7.03 7.03 0 0 1 9.94 9.94L12 20.94l-4.97-4.97a7.03 7.03 0 0 1 0-9.94Zm11-1.06A8.53 8.53 0 0 0 5.97 17.03l5.5 5.5a.75.75 0 0 0 1.06 0l5.5-5.5a8.53 8.53 0 0 0 0-12.06ZM10.75 11a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0ZM12 8.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5Z",
		clipRule: "evenodd"
	})
});
export default SvgMapPin;
